
import React, { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { GoogleMap } from "../GoogleMap";

interface CardImageProps {
  nhSlug: string;
  centerName: string;
  address?: string;
}

export function CardImage({ nhSlug, centerName, address }: CardImageProps) {
  const [isImageLoading, setIsImageLoading] = useState(true);
  
  const generateBackgroundColor = (name: string) => {
    const colors = [
      "bg-grandpal-beige", // Main brand beige
      "bg-grandpal-green-lighter", // Light green
      "bg-gray-100", // Light gray
      "bg-stone-100", // Warm gray
      "bg-emerald-50", // Very light green
      "bg-slate-100", // Cool gray
      "bg-zinc-100", // Neutral gray
      "bg-sage-100", // Sage green
      "bg-olive-100" // Olive green
    ];
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsImageLoading(false);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  console.log("CardImage rendering with:", { nhSlug, centerName, address });

  if (isImageLoading) {
    return (
      <div className="relative w-full h-48">
        <Skeleton className="absolute inset-0 w-full h-full" />
      </div>
    );
  }

  if (address) {
    return (
      <div className="w-full h-48 rounded-t-lg overflow-hidden">
        <GoogleMap 
          address={address} 
          size="medium" 
          showCard={false}
          className="w-full h-full"
        />
      </div>
    );
  }

  return (
    <div className={`w-full h-48 flex items-center justify-center ${generateBackgroundColor(centerName || '')}`}>
      <div className="text-center p-4">
        <MapPin className="h-10 w-10 text-grandpal-green mx-auto mb-2" aria-hidden="true" />
        <p className="text-grandpal-green font-medium line-clamp-2">{centerName || "Nursing Home"}</p>
        {address && (
          <p className="text-grandpal-gray text-sm mt-1 line-clamp-2">{address}</p>
        )}
      </div>
    </div>
  );
}
